import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, message } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import logo from "../../../Assets/Images/logo.svg";
import email from "../../../Assets/Icons/email.svg";
import { resendForgotPassword } from "../../../API/auth";
import getErrorMessage from "../../../Utlis/ErrorMessage";
import PortalConfig from "../../../Utlis/PortalConfig";
import "./style.css";

const CheckEmail = ({ portal }) => {
  const config = PortalConfig[portal];
  const navigate = useNavigate();
  const location = useLocation();
  const userEmail = location.state?.email;
  const [resending, setResending] = React.useState(false);

  const handleBack = () => {
    navigate(config.loginRoute);
  };

  const handleResend = async () => {
    if (!userEmail) {
      navigate(config.forgotPasswordRoute);
      return;
    }

    setResending(true);
    const res = await resendForgotPassword({
      email: userEmail,
      tenant_type: location.state?.tenantType || config.loginTenantTypes[0],
    });
    setResending(false);

    if (res?.status === 200) {
      message.success(
        getErrorMessage(res, "A new reset link has been sent to your email."),
      );
    } else {
      message.error(getErrorMessage(res, "Could not resend the reset link."));
    }
  };
  return (
    <div className="verify">
      <div className="verify-page">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="verify-card">
          <div className="top-gradient"></div>
          <div className="email-logo">
            <img src={email} alt="email" />
          </div>

          <div className="content-heading">Check Your Email</div>
          <div className="sub-heading">
            We’ve sent a password reset link to your email address
            {userEmail ? ":" : "."}
            {userEmail && <div className="email"> {userEmail}</div>}
          </div>

          <div className="bottom-info">Didn’t receive the email?</div>
          <div
            className="resend-link"
            onClick={resending ? undefined : handleResend}
            style={
              resending ? { opacity: 0.6, pointerEvents: "none" } : undefined
            }
          >
            {resending ? "Resending..." : "Resend Link"}
          </div>

          <Button
            type="primary"
            htmlType="submit"
            className="submit-button"
            onClick={handleBack}
          >
            <ArrowLeftOutlined />
            Back To Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CheckEmail;
